import React from 'react'
import { Hero } from './Hero'
import { Established } from './Established'
import { Capabilities } from './Capabilities'
import { Projects } from './Projects'
import OurClients from './OurClients'
import { Enquery } from './Enquery'
import { FeedBack } from './FeedBack'

export const Home = () => {
  return (
    <div>
       <Hero />
       <Established />
       <Capabilities />
       <Projects />
       <OurClients />
       <FeedBack />
       <Enquery />
    </div>
  )
}
